import { Box, BoxProps } from "@chakra-ui/react";

export function PinIcon({ ...props }: BoxProps) {
  return (
    <Box cursor={"pointer"} {...props}>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 27.4987L16.6667 23.332"
          stroke="#5C6670"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.0488 25.7261C17.9294 25.0179 14.9821 22.0706 14.2739 18.9513C14.1617 18.4574 14.1057 18.2105 14.2681 17.81C14.4305 17.4094 14.6289 17.2855 15.0257 17.0376C15.9226 16.4772 16.8939 16.2991 17.9018 16.3882C19.3162 16.5133 20.0233 16.5759 20.3761 16.3921C20.7289 16.2083 20.9686 15.7785 21.4481 14.9189L22.0554 13.83C22.4555 13.1127 22.6556 12.7541 23.1261 12.585C23.5967 12.4159 23.8799 12.5183 24.4463 12.7231C25.7708 13.202 26.7981 14.2292 27.277 15.5537C27.4817 16.1201 27.5841 16.4033 27.4151 16.8739C27.246 17.3445 26.8873 17.5445 26.17 17.9446L25.0561 18.566C24.1981 19.0445 23.7691 19.2838 23.5854 19.64C23.4017 19.9962 23.4684 20.688 23.6019 22.0716C23.7 23.089 23.5309 24.0667 22.963 24.9747C22.7148 25.3715 22.5908 25.5699 22.1903 25.7321C21.7898 25.8944 21.5428 25.8383 21.0488 25.7261Z"
          stroke="#5C6670"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Box>
  );
}
